



import React, { useState } from 'react';
import styles from './Contact.module.css';

import logo from '../../assets/abk.png';
// import logo from '../../assets/halal.jpeg';

import Button from '../button/Button';
import Button2 from '../button2/Button2';
import Button3 from '../button3/Button3';
import Icon from '../icon/Icon';
import WaveTop from '../wave/WaveTop';
import WaveBottom from '../wave/WaveBottom';

import { FaArrowRight } from "react-icons/fa6";
import { MdPhoneCallback } from "react-icons/md";
import { IoMail } from "react-icons/io5";
import { FaGlobe } from "react-icons/fa6";

import emailjs from '@emailjs/browser';

const Contact = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = () => {
    setLoading(true);

    emailjs.send(
      "service_l2r4tkr",   // 🔥 replace
      "template_zzaftzi",  // 🔥 replace
      {
        from_name: form.name,
        from_email: form.email,
        phone: form.phone,
        message: form.message,
      },
      "ZTKYWdIvUSrBslRtW"    // 🔥 replace
    )
    .then(() => {
      alert("Message Sent ✅");
      setForm({ name: "", email: "", phone: "", message: "" });
      setLoading(false);
    })
    .catch((error) => {
      console.error(error);
      alert("Failed ❌");
      setLoading(false);
    });
  };

  return (
    <div id="contactus" className={styles.parent}>
      <WaveTop />

      <div className={styles.main}>

        {/* LEFT */}
        <div className={styles.left}>
          <Button2 text="Contact Us" style={{ color: "#fff" }} />
          <h3>Collaborate <span>with us</span></h3>

          <p style={{marginBottom: "25px"}}>
            Get in touch with us for questions, partnerships, or anything you'd like to know about our drinks.
          </p>

          <Button3 text="+6012-280-0091" Icon={MdPhoneCallback} />
          <Button3 text="fusionsip.abk@gmail.com" Icon={IoMail} />
          <Button3 text="fusionsip.co" Icon={FaGlobe} />
            <img src={logo} alt="logo" className={styles.logo} />
          <p style={{margin: "14px 0px 14px 0px"}}>Company Reg. No. - 202501019314 (1620727-P)</p>
          <p>
            {/* Fushionship Beverages Pvt. Ltd.<br />
            B-27, 2nd Floor, Nehru Place New Delhi,<br />
            Delhi 110019 India */}
            No. 14, Jalan Bukit 10, Kawasan Perindustrian MIEL Seri Alam, 81750, Johor Bahru, Johor
          </p>
            
            
          {/*<p>The company Registration Number :<br />202501019314 (1620727-P)</p> */}
        </div>

        {/* RIGHT */}
        <div className={styles.right}>
          
          <input
            type="text"
            name="name"
            placeholder="Name"
            className={styles.input}
            value={form.name}
            onChange={handleChange}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            className={styles.input}
            value={form.email}
            onChange={handleChange}
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            className={styles.input}
            value={form.phone}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Message"
            className={styles.textarea}
            rows="7"
            value={form.message}
            onChange={handleChange}
          />

          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Button 
              text={loading ? "Sending..." : "CONTACT US"} 
              onClick={handleSubmit} 
            />
            <Icon Icon={FaArrowRight} /> 
            {/* <button 
              onClick={handleSubmit} 
            >{loading ? "Sending..." : "CONTACT US"} </button>
            <Icon Icon={FaArrowRight} /> */}
          </div>

        </div>

      </div>

      <WaveBottom />
    </div>
  );
};

export default Contact;


// import React from 'react';
// import styles from './Contact.module.css';

// import Button from '../button/Button';
// import Button2 from '../button2/Button2';
// import Button3 from '../button3/Button3';
// import Icon from '../icon/Icon';
// import WaveTop from '../wave/WaveTop';
// import WaveBottom from '../wave/WaveBottom';


// import { FaArrowRight } from "react-icons/fa6";


// import { MdPhoneCallback } from "react-icons/md";
// import { IoMail } from "react-icons/io5";
// import { FaGlobe } from "react-icons/fa6";

// const Contact = () => {
//     return (
//         <div id="contactus" className={styles.parent}>
//             <WaveTop />
//             <div className={styles.main}>
//                 <div className={styles.left}>
//                     <Button2 text="Contact Us" style={{color: "#fff"}} />
//                     <h3>Collaborate <span>with us</span></h3>
//                     <p>Get in touch with us for questions, partnerships, or anything you'd like to know about our drinks.</p>
//                     <Button3 text="+123 567 7867 78" Icon={MdPhoneCallback} />
//                     <Button3 text="+123 567 7867 78" Icon={IoMail} />
//                     <Button3 text="+123 567 7867 78" Icon={FaGlobe} />
//                     <p style={{marginTop: "30px"}}>Fushionship Beverages Pvt. Ltd.<br /> B-27, 2nd Floor, Nehru Place New Delhi,<br /> Delhi 110019 India</p>
//                 </div>
//                 <div className={styles.right}>
//                     <input
//                         type="text"
//                         placeholder="Name"
//                         className={styles.input}
//                     />
//                     <input
//                         type="text"
//                         placeholder="Email"
//                         className={styles.input}
//                     />
//                     <input
//                         type="text"
//                         placeholder="Phone Number"
//                         className={styles.input}
//                     />
//                     <textarea
//                         placeholder="Message"
//                         className={styles.textarea}
//                         rows="7"
//                     />
//                     <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
//                         <Button text="CONTACT US" />
//                         <Icon Icon={FaArrowRight} />
//                     </div>
//                 </div>
//             </div>
//             <WaveBottom />
//         </div>
//     )
// }

// export default Contact;